import { useState, useEffect } from 'react';
import { awardsService } from '../services/dataService';

/**
 * Custom hook to fetch awards from Firestore
 * @returns {Object} { awards, loading, error, refetch }
 */
export const useAwards = () => {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAwards = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await awardsService.getAll();
      
      if (result.success) {
        // Sort by order field
        const sortedAwards = result.data.sort((a, b) => (a.order || 0) - (b.order || 0));
        setAwards(sortedAwards);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAwards();
  }, []);

  return {
    awards,
    loading,
    error,
    refetch: fetchAwards
  };
};